import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import FullScreen from '@blade/common/components/full-screen.vue';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import WhiteGroup from './components/group.vue';
import WhiteStaff from './components/staff.vue';
let default_1 = class extends Vue {
    activeName = 'GROUP';
    keyword = '';
    search = '';
    libId = [];
    handleTabChange(val, event) {
        if (val?.name === 'GROUP') {
            this.libId = [];
        }
        this.$router.push({ path: '/traffic/staff/white', query: { group: val?.name || 'GROUP' } });
    }
    handleSearch() {
        console.log('search:', this.$refs);
        if (this.activeName === 'GROUP') {
            this.$refs.group.handleSearch(this.keyword);
        }
        else {
            this.$refs.staff.handleSearch(this.keyword);
        }
    }
    handleClear() {
        this.keyword = '';
    }
    handleGroupNameClick(libId) {
        this.libId = [libId];
        this.activeName = 'STAFF';
        this.handleTabChange({ name: 'STAFF' }, {});
    }
    mounted() {
        const { query } = this.$route;
        if (query) {
            this.activeName = query.group || 'GROUP';
        }
    }
};
default_1 = __decorate([
    Component({
        name: 'WhiteMain',
        components: {
            FullScreen,
            AuthItem,
            WhiteGroup,
            'white-staff': WhiteStaff,
        },
        i18n: {
            messages: {
                'en-us': {
                    searchHold: 'Name/ID/Group Name',
                    group: 'Group',
                    staff: 'User',
                },
                zh: {
                    searchHold: '姓名/ID/人员组名称',
                    group: '人员组',
                    staff: '人员',
                },
            },
        },
    })
], default_1);
export default default_1;
